// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__9zalm","left":"InfoRow_left__1TX8u"};